<template>
  <div :style="{ padding: '30px' }">
    <div class="flex">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <h3>Como fui avaliado (Avaliação 360)</h3>
    </div>
    <br />
    <h3 v-if="vazio">Ninguém respondeu essa avaliação</h3>
    <div
      v-for="n in repetir"
      :key="n"
      style="border: #e6e6e6; border-radius: 10px"
    >
      <div>
        <h3 v-if="(Object.keys(notasRecebidas).length === 0) & (n == repetir)">
          Somente você respondeu essa avaliação!
        </h3>
      </div>
      <QuestionSet
        v-if="!vazio & (Object.keys(notasRecebidas).length !== 0)"
        :titulo="descricaoClassificacao[n - 1]"
        :visualizar="true"
        :pergunta="listaQuestoes[n - 1]"
        :quantidade="listaQuestoes[n - 1].length"
        :quantidade-linhas="
          notasRecebidas[Object.keys(notasRecebidas)[0]].length
        "
        :notas-recebidas="notasRecebidas"
        :auto-avaliacao="autoAvaliacao[n - 1]"
        @retorna-ao-pai="handleOptionsNotas"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import QuestionSet from '@/components/QuestionSet.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    QuestionSet,
  },
  mounted() {
    var aux = -1;
    var notasRecebidas = {};
    var listaQuestoes = [];
    var descricaoClassificacao = [];
    axios
      .get(
        `${API_URL}/avaliacoes/minhasnotas/${this.$route.params.id}/${this.$route.params.id_proj}`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        },
      )
      .then((response) => {
        var dados = response.data;
        this.vazio = dados.tb_avaliacao_item.length <= 0;
        dados.tb_avaliacao_item.forEach((dado) => {
          if (!(dado.tb_item_de_avaliacao.descricao in notasRecebidas)) {
            if (dado.id_usuario_avaliador != dado.id_usuario_avaliado) {
              notasRecebidas[dado.tb_item_de_avaliacao.descricao].push(
                dado.nota,
              );
            } else {
              this.autoAvaliacao.push(dado.nota);
            }
          } else {
            notasRecebidas[dado.tb_item_de_avaliacao.descricao] = [];
            if (dado.id_usuario_avaliador != dado.id_usuario_avaliado) {
              notasRecebidas[dado.tb_item_de_avaliacao.descricao].push(
                dado.nota,
              );
            }
          }
          if (
            !descricaoClassificacao.includes(
              dado.tb_item_de_avaliacao.tb_classificacao.descricao,
            )
          ) {
            listaQuestoes.push([]);
            descricaoClassificacao.push(
              dado.tb_item_de_avaliacao.tb_classificacao.descricao,
            );
            aux++;
          }
          var controlaLoop = 0;
          listaQuestoes.forEach((lista) => {
            if (lista.includes(dado.tb_item_de_avaliacao.descricao)) {
              controlaLoop++;
            }
          });
          if (controlaLoop == 0) {
            listaQuestoes[aux].push(dado.tb_item_de_avaliacao.descricao);
          }
        });
        this.listaQuestoes = listaQuestoes;
        this.descricaoClassificacao = descricaoClassificacao;
        this.notasRecebidas = notasRecebidas;
        this.repetir = descricaoClassificacao.length;
      })
      .catch((error) => {
        console.error(error);
      });
    console.log('quests:', this.listaQuestoes);
  },
  data: () => ({
    vazio: false,
    repetir: null,
    titulo: null,
    listaQuestoes: null,
    descricaoClassificacao: null,
    notasRecebidas: null,
    autoAvaliacao: [],
  }),
};
</script>

<style scoped>
.linha {
  border: 1px solid #707070;
}
.flex {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
